/**
 * Content page body fades up as it loads — a single load-time reveal
 * rather than scroll-triggered, since this content is usually short
 * enough to be near the top of the page already.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-content-page__body', { y: 20, scale: 1, duration: 0.7, start: 'top 95%' });
